import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Autocomplete, TextField } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../../core/BaseComponents/Modal";
import { FaImage } from "react-icons/fa";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../../utils/utils";
import { faImages } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteBackgroundImage from "./DeleteBackgroundImage";
import PreviewBgImage from "./PreviewBgImage ";
import Custom_Paingation from "../../../../core/BaseComponents/Custom_Paingation";
import { useSelector } from "react-redux";
import ImageResolutionTooltip from "../../../ConfigurationNewHotel/ImageResolutionTooltip";

function ConfigurationBackgroundImage() {
  const [partnerConfigList, setPartnerConfigList] = useState([]);
  const [confirmDeletePartnerRow, setConfirmDeletePartnerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePartnerPopUp, setDeletePartnerPopUp] = useState(false);
  const [editPartnerConfig, setEditPartnerConfig] = useState(false);
  const [editPartnerRowUpdate, setEditPartnerRowUpdate] = useState(false);
  const [createPartnerSuccessMsg, setCreatePartnerSuccessMsg] = useState('');
  const [editPartnerSid, setEditPartnerSid] = useState("");
  const [loader, setLoader] = useState(false);
  const [fileError, setFileError] = useState("");
  const [files, setFiles] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [resetData, setResetData] = useState({});
  const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);
  const [flag, setFlag] = useState(false);
  const [roomTypesMaster, setRoomTypesMaster] = useState([]);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState('');

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)

  const recordsPerPage = 10;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control
  } = useForm({
    mode: 'onChange',
    defaultValues: {bgOpacity : 70}
  });
  const { chainId } = useSelector((state) => state.chainIdReducer);

  let validPermissionClassName = isValidRole("BACKGROUND_IMAGE_MODIFY")
    ? ""
    : "btn-disable-permission";

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });

  const backgroundImageOpacityValues = [60,70,80,90]

  const backgroundImage = [
    {
      name: "Background Image",
      files: 1,
      size: "700 KB",
      height: 1080,
      width: 1920,
      resolution: "72 PPI",
      aspect: "16:09",
      formats: "JPG, JPEG, PNG",
    }
  ]

  const onSubmit = (data) => {
    if (fileUrl === '') {
      setFileError('Upload background image required');
      return;
    }
    if(fileError!==""){
      return;
    }
    const formData = new FormData();
    formData.append('bgImage', files);
    let method = "POST";
    let url = `/bg-image/upload?isPublished=true&title=${data?.title}&roomTypes=${data?.roomTypes}&bgOpacity=${data?.bgOpacity}`;
    if (editPartnerRowUpdate) {
      method = "PUT"
      url = `/bg-image/${editPartnerSid?.sid}?isPublished=false&title=${data?.title}&roomTypes=${data?.roomTypes}&bgOpacity=${data?.bgOpacity}`;
    }

    callAPI(url, method, formData, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
          title: '',
          roomTypes:[],
          bgOpacity : 70
        });
        setFileUrl('');
        setFiles('');
        setCreatePartnerSuccessMsg(response?.message);
        PartnerListApi();
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const onSave = (data) => {
    if (fileUrl === '') {
      setFileError('Upload background image required');
      return;
    }
    if(fileError!==""){
      return;
    }
    const formData = new FormData();
    formData.append('bgImage', files);
    let method = "POST";
    let url = `/bg-image/upload?isPublished=false&title=${data?.title}&roomTypes=${data?.roomTypes}`;
    callAPI(url, method, formData, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
          title: '',
          roomTypes: [],
          bgOpacity : 70
        });
        setFileUrl('');
        setFiles('');
        setCreatePartnerSuccessMsg(response?.message);
        PartnerListApi();
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };
  const isPartnerDeletedRef = useRef({
    isPartnerDeletedModalData: null,
    userConformationModalData: null,
  });

  const deletePartnerConfigPopUpHandler = (row) => {
    setDeletePartnerPopUp(true);
    const newModalRefData = {
      isPartnerDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPartnerDeletedRef.current = newModalRefData;
  }

  const deletePartnerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePartnerRow === "") {
      return
    }

    if (confirmDeletePartnerRow === `Delete ${isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.title}`) {
      setConfirmValidate(false)
      const { row } = isPartnerDeletedRef.current?.isPartnerDeletedModalData;
      callAPI(`/bg-image/${row?.sid}`, "DELETE", {}, { chainId: getChainIdLS() })
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPartnerDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPartnerDeletedRef.current = newModalRefData;
          PartnerListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      title: '',
      roomTypes: [],
      bgOpacity : 70
    });
    setFileUrl('');
    setFiles('');
  }

  const publishUnPublishPopUpHandler = (row) => {
    setPublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishModalData: {
        message: `Do you really want to ${row?.published ? 'Un-Publish' : 'Publish'} the Background Image Configuration?`,
        row
      }
    };
    isPublishedUnPublishedRef.current = newModalRefData;
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("BACKGROUND_IMAGE_MODIFY")?<>
        {/* {!row?.published ? <>
          <Tooltip title="Edit" arrow>
            <MdModeEditOutline
              className="edit-icon-enable"
              onClick={() => { setEditPartnerConfig(true); setEditPartnerSid(row) }}
            />
          </Tooltip>
          <Tooltip title="Delete" className="cursor-pointer" arrow>
            <DeleteIcon
              className="delete-icon-enable"
              onClick={() => {
                deletePartnerConfigPopUpHandler(row);
              }}
            />
          </Tooltip>
        </> : <>
          <Tooltip title="Un-Publish to perform actions">
            <span>
              <MdModeEditOutline className="edit-icon-disable" arrow />
            </span>
          </Tooltip>
          <Tooltip title="Un-Publish to perform actions">
            <DeleteIcon className="delete-icon-disable" arrow />
          </Tooltip>
        </>
        } */}
        <Tooltip title={`${row?.published ? 'un-publish' : 'publish'}`} className="cursor-pointer" arrow>
          <button type="button"
            className={`${row?.published ? 'un-published' : 'published'}`}
            onClick={() => publishUnPublishPopUpHandler(row)}
          >
            {row?.published ? 'Un-Publish' : 'Publish'}
          </button>
        </Tooltip>
      </>:
      <>
      {/* <Tooltip title="Don't have permission to edit" arrow>
        <span>
          <MdModeEditOutline className="edit-icon-disable" />
        </span>
      </Tooltip>
      <Tooltip title="Don't have permission to delete" arrow>
        <DeleteIcon className="delete-icon-disable" />
      </Tooltip> */}
      <Tooltip title="Don't have permission to edit" className="cursor-pointer" arrow>
        <span>
          <button type="button"
            className={`${row?.published ? 'un-published' : 'published'} ${validPermissionClassName}`}
            // onClick={() => publishUnPublishPopUpHandler(row)}
          >
            {row?.published ? 'Un-Publish' : 'Publish'}
          </button>
          </span>
        </Tooltip>
    </>
    );
  };

  const columns = [
    { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "title", headerName: "Background Title", flex: 1 },
    { field: "roomTypes", headerName: "Room Types", flex: 1, row: true, renderCell: (row) => row?.roomTypes?.map((item, index) => <span>{index ? ',' : ''} {item}</span>) },
    { field: 'bgImageUrl', headerName: 'Background Image', flex: 1, row: true, renderCell: (row) => (<img src={row?.bgImageUrl} alt={row?.sid} className="background-config-img" onClick={() => setShowPreviewPopUp(row?.bgImageUrl)} />), disableSortIcon: true, },
    // {
    //   field: "actionCell",
    //   row: true,
    //   headerName: "Actions",
    //   flex: 0.5,
    //   renderCell: renderActionIcon,
    //   sortDirection: false,
    //   disableSortIcon: true,
    // },
  ];

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const PartnerListApi = () => {
    // const apiPath = `banner/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(`/bg-image?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {}, { chainId: getChainIdLS() })
      .then((response) => {
        const temp = response?.backgroundResponse?.filter((data)=>data?.published)
        setPartnerConfigList(temp)
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        setPaginationError("")
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    PartnerListApi();
  }, [selectedPage, chainId]);

  useEffect(() => {
    callAPI("/get-room-types", "GET", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setRoomTypesMaster(res);
      })
      .catch((err) => {
        console.warn(err.message);
      });
      cancelPartnerHandler()
  }, [chainId]);

  const popupCloseHandler = () => {
    setDeletePartnerPopUp(false);
  };


  useEffect(() => {
    if (editPartnerConfig) {
      getPartnerListSidHandler();
      setEditPartnerConfig(false);
    }
    ScrollToTop();
    setFileError('');
  }, [editPartnerConfig]);

  const getPartnerListSidHandler = () => {
    callAPI(`/bg-image/background-image?sid=${editPartnerSid?.sid}`, "GET", {}, { chainId: getChainIdLS() })
      .then(function (response) {
        const payload = {
          title: response?.title,
          roomTypes: response?.roomTypes,
          bgOpacity: response?.bgOpacity?response?.bgOpacity:70
        };
        setFileUrl(response?.bgImageUrl);
        reset(payload);
        setResetData(response?.bgImageUrl)
        setEditPartnerRowUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
    setFileUrl(resetData);
    setFileError('');
  }

  const cancelPartnerHandler = () => {
    reset({
      title: '',
      roomTypes: [],
      bgOpacity : 70
    });
    setFileUrl('');
    setFiles('');
    setEditPartnerRowUpdate(false);
    setEditPartnerSid('');
    setEditPartnerConfig(false);
  }

  const uploadOrDragFileHandler = (fileList) => {
    let bytes = (fileList.size / 1024).toFixed(2);
    setFileUrl(URL.createObjectURL(fileList));
    if (bytes > 700) {
      setFileError('Upload file should be less than 700KB');
      return;
    }
    setFiles(fileList);
    setFileError('');
  }
  const deleteLogoHandler = () => {
    setFiles('');
    setFileUrl('');
    setFileError('');
  };

  const publishUnPublishHandler = () => {
    const apiPath = `/bg-image/background/publish?sid=${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.sid}&isPublished=${!(isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.published)}`;
    callAPI(apiPath, "PUT", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setFlag(!flag)
        let successMessage = res.message
        const newModalRefData = {
          isPublishUnPublishModalData: {
            message: successMessage
          }
        };
        isPublishedUnPublishedRef.current = newModalRefData;
        PartnerListApi();
      })
      .catch((err) => {
        console.warn(err.message);
        setPublishUnPublishPopUp(false);
      });
  }

  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">{editPartnerRowUpdate ? 'Edit Background Image Configuration' : 'Background Image Configuration'}</p>
            </div>
              <div className="form-group-hotel col-4">
                <div className="floating-label">
                  <FaImage className="new-hotel-icons" />
                  <input
                    id="title"
                    maxLength={25}
                    placeholder=""
                    {...register("title", {
                      required: "Background Image Title Required",
                    })}
                  />
                  <label htmlFor="title">Background Image Title</label>
                </div>
                {errors.title && (
                  <small className="required">{errors.title.message}</small>
                )}
              </div>
            <div className="col-4 form-group-hotel">
              <div className="floating-select-label">
                <Controller
                  name="roomTypes"
                  control={control}
                  rules={{
                    validate: value =>
                      Array.isArray(value) && value?.length > 0 || 'Please Select Room Type'
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                      limitTags={2}
                      disablePortal
                      multiple
                      options={roomTypesMaster}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value || []}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Select Room Type"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.roomTypes && (
                <small className="required">{errors.roomTypes?.message}</small>
              )}
            </div>
            <div className="col-4 form-group-hotel">
              <div className="floating-select-label">
                <Controller
                  name="bgOpacity"
                  control={control}
                  rules={{
                    validate: value =>
                      (value !== undefined && value !== null && value !== '') || 'Please Select Background Image Opacity'
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field?.value ? 'Mui-focused' : ''}`}
                      // limitTags={2}
                      disablePortal
                      // multiple
                      options={backgroundImageOpacityValues}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field?.value || []}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Select Background Image Opacity"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.bgOpacity && (
                <small className="required">{errors.bgOpacity?.message}</small>
              )}
            </div>
            <div className="col-12">
              {fileUrl !== "" ? <div className="partner-logo">
                <img src={fileUrl} alt={fileUrl} />
                <span onClick={() => deleteLogoHandler()}>X</span>
              </div>
                : <FileUploader
                  name="file"
                  types={["JPG", "PNG", 'JPEG']}
                  handleChange={uploadOrDragFileHandler}
                  classes="drag-file file-upload-bg"
                  children={
                    <>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                      <p className="drag-text">
                        Drag and drop logo or
                        <span> Browse</span>
                        <br />
                        To upload <span className="Roboto-Bold text-black">Background Image</span> here.
                      <ImageResolutionTooltip data={backgroundImage}/>
                      </p>
                      {/* <h6> Formats Supported : JPG, JPEG and PNG</h6> */}
                    </>
                  }
                />
              }

              {fileError && <p className="required">{fileError}</p>}
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="button" className="clear-btn me-2" onClick={cancelPartnerHandler}>{editPartnerRowUpdate ? "Cancel" : "Clear All"}</button>
            {editPartnerRowUpdate && <>
              <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
            </>}
            {/* {!editPartnerRowUpdate && <button type="button" onClick={handleSubmit(onSave)} className={`disable-btn me-2 ${validPermissionClassName}`}>Save</button>} */}
            <button type="button" onClick={handleSubmit(onSubmit)} className={`create-btn ${validPermissionClassName}`}>{editPartnerRowUpdate ? "Update" : "Publish"}</button>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Background Image Configuration List</b></p>

          <TableWrapper
            data={partnerConfigList}
            columns={columns}
            noPagination={true}
            module="partner-config"
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      {deletePartnerPopUp && <DeleteBackgroundImage
        deletePartnerPopUp={deletePartnerPopUp}
        isPartnerDeletedRef={isPartnerDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deletePartnerHandler={deletePartnerHandler}
        setConfirmDeletePartnerRow={setConfirmDeletePartnerRow}
        confirmDeletePartnerRow={confirmDeletePartnerRow}
        confirmValidate={confirmValidate}
      />}
      <BasicModal
        popupOpen={createPartnerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createPartnerSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreatePartnerSuccessMsg(''); setEditPartnerRowUpdate(false); PartnerListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
      {showPreviewPopUp !== "" && <PreviewBgImage
        showPreviewPopUp={showPreviewPopUp}
        setShowPreviewPopUp={setShowPreviewPopUp}
      />}
      <BasicModal
        popupOpen={publishUnPublishPopUp}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<>
          {isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData && <p className="mt-2">{isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message}</p>}
        </>
        }
        footer={
          isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Publish the Background Image Configuration?" ||
            isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Un-Publish the Background Image Configuration?" ? {
            primaryButton: {
              buttonName: "Cancel",
              action: () => setPublishUnPublishPopUp(false)
            },
            secondaryButton: {
              buttonName: isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.published ? 'Un-Publish' : 'Publish',
              action: publishUnPublishHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: () => setPublishUnPublishPopUp(false)
            }
          }
        }
      />
    </div>
  )
}

export default ConfigurationBackgroundImage;